import * as Schema from "effect/Schema";
import { HostStoreTargetRefusalWire } from "./hostStoreLockout.ts";
import { LocalServiceSupervision } from "./localLifecycle.ts";
import { PositiveInt } from "./baseSchemas.ts";

export const CommandLineLifecycleCommand = Schema.Literals(["start", "run", "status", "stop"]);
export type CommandLineLifecycleCommand = typeof CommandLineLifecycleCommand.Type;

export const CommandLineLifecycleCode = Schema.Literals([
  "starting",
  "ready",
  "stopped",
  "already-stopped",
  "unsupported-target-platform",
  "invalid-application-installation",
  "runtime-dependency-unavailable",
  "host-store-recovery-required",
  "host-store-access-error",
  "runtime-identity-conflict",
  "listener-unavailable",
  "spawn-failed",
  "exited-before-readiness",
  "readiness-timeout",
  "shutdown-timeout",
  "system-error",
]);
export type CommandLineLifecycleCode = typeof CommandLineLifecycleCode.Type;

export const CommandLineLifecycleRecord = Schema.Struct({
  command: CommandLineLifecycleCommand,
  phase: Schema.Literals(["starting", "ready", "blocked", "stopped", "failed", "status"]),
  code: CommandLineLifecycleCode,
  release: Schema.String,
  message: Schema.String,
  /**
   * The AFAR Host Store root this lifecycle result acted on. Always present:
   * two entry points that resolve different roots are two AFAR Host
   * Installations and may both run, so a result that does not name its root
   * cannot be told apart from a broken single-service guarantee. See ADR-0113.
   */
  storePath: Schema.String,
  supervision: Schema.optionalKey(LocalServiceSupervision),
  pid: Schema.optional(PositiveInt),
  listener: Schema.optional(Schema.String),
  executingRelease: Schema.optional(Schema.String),
  /**
   * The lifecycle operation that refused, when one did. Several distinct
   * conditions share a single lifecycle code — `runtime-identity-conflict`
   * most of all — and this is what tells them apart without splitting the code.
   */
  failedOperation: Schema.optional(Schema.String),
  /**
   * The path the refusal named, when it is not the store root. A Host Store
   * Access Error is usually about one target inside the store, and the root
   * alone does not say which one to restore.
   */
  failedPath: Schema.optional(Schema.String),
  /** The property that refused, when the service named one. */
  refusal: Schema.optional(HostStoreTargetRefusalWire),
});
export type CommandLineLifecycleRecord = typeof CommandLineLifecycleRecord.Type;
